// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Search2 from "../common/Search2.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as ItemName from "common/src/tft-static/ItemName.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as StatsConfig from "../stats/StatsConfig.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as SearchField2 from "../components/SearchField2.bs.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import OpenInFull from "@mui/icons-material/OpenInFull";
import FormControlLabel from "@mui/material/FormControlLabel";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Item");
        }), undefined, (function (param, param$1, param$2) {
          var itemId = param[0];
          return React.createElement(ItemTooltip.make, {
                      itemId: itemId,
                      children: React.createElement("div", {
                            className: "flex items-center"
                          }, React.createElement("div", {
                                className: "pr-2 flex-shrink-0"
                              }, React.createElement(ItemImage.make, {
                                    itemId: itemId,
                                    size: 26,
                                    rounded: "rounded"
                                  })), React.createElement("div", {
                                className: "truncate font-roboto font-normal"
                              }, React.createElement(ItemName.make, {
                                    itemId: itemId
                                  })))
                    });
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param$2.itemsT(param[0]);
        }), undefined, 175, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (param, param$1, param$2) {
          var itemStats = param[1];
          return React.createElement(Tooltip.make, {
                      title: T.humanReadableCount(itemStats.count) + " games",
                      children: React.createElement("div", undefined, Global.toFixed(undefined, Global.f(itemStats.count) / Global.f(param$1[0]) * 8) + "/8")
                    });
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].count;
        }), undefined, 97, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (param, param$1, param$2) {
          return Global.toFixed(undefined, param[1].place);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].place;
        }), undefined, 70, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct3(param[1].top4);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].top4;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct3(param[1].won);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].won;
        }), undefined, 74, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return param$1.t("Top Users");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", {
                      className: "flex gap-1"
                    }, Belt_Array.map(Belt_Array.slice(param[1].topUsers, 0, 5), (function (param) {
                            var unitId = param[0];
                            return React.createElement(UnitTooltip.make, {
                                        unit: unitId,
                                        children: React.createElement(UnitImage.make, {
                                              unitId: unitId,
                                              size: 30
                                            }),
                                        key: unitId
                                      });
                          })));
        }), undefined, undefined, undefined, undefined, false, 194, undefined, undefined),
  StatsTable2.col(undefined, undefined, (function (param, param$1) {
          return null;
        }), "h-1", (function (param, param$1, param$2) {
          return React.createElement(Link.make, {
                      className: "flex items-center",
                      route: {
                        TAG: /* Stats */0,
                        _0: {
                          TAG: /* Item */6,
                          id: param[0],
                          aperture: param$1[1]
                        }
                      },
                      children: React.createElement(IconButton, {
                            onClick: (function (param) {
                                
                              }),
                            size: "small",
                            children: React.createElement(OpenInFull, {
                                  fontSize: "small"
                                })
                          })
                    });
        }), "pl-0 pr-0", undefined, undefined, undefined, undefined, 38, undefined, undefined)
];

function ItemsPage(Props) {
  var statsData = Props.statsData;
  var itemsStats = Belt_MapString.fromArray(Belt_Array.map(statsData.items, (function (i) {
              return [
                      i.itemId,
                      i
                    ];
            })));
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return "";
      });
  var search = match[0];
  var aperture = ApertureCtx.useValue(undefined);
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowNormalItems = match$1[1];
  var showNormalItems = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowOrnnItems = match$2[1];
  var showOrnnItems = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setShowEmblems = match$3[1];
  var showEmblems = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setShowRadiantItems = match$4[1];
  var showRadiantItems = match$4[0];
  var match$5 = React.useState(function () {
        return false;
      });
  var setShowSupportItems = match$5[1];
  var showSupportItems = match$5[0];
  var match$6 = React.useState(function () {
        return false;
      });
  var setShowOtherItems = match$6[1];
  var showOtherItems = match$6[0];
  var set = TftSet.use(undefined);
  var data = React.useMemo((function () {
          return Belt_MapString.toArray(itemsStats);
        }), [itemsStats]);
  var keyFn = React.useCallback((function (param) {
          return param[0];
        }), []);
  var tableClass = [];
  var showAllItems = showNormalItems && showOrnnItems && showEmblems && showRadiantItems && showSupportItems && showOtherItems || !showNormalItems && !showOrnnItems && !showEmblems && !showRadiantItems && !showSupportItems && !showOtherItems;
  var searchIds = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Belt_SetString.fromArray(Search2.searchItemsArr(search, set));
          }
        }), [search]);
  var context = React.useMemo((function () {
          return [
                  statsData.totalEntries,
                  aperture
                ];
        }), [
        statsData.totalEntries,
        aperture
      ]);
  var visibleFilter = React.useCallback((function (param) {
          var id = param[0];
          var passItemTyp;
          if (showAllItems) {
            passItemTyp = true;
          } else {
            try {
              var info = Data.itemInfoExn(id, set);
              passItemTyp = showNormalItems && info.tags.includes("Craftable") || showEmblems && (info.tags.includes("CraftableEmblem") || info.tags.includes("ElusiveEmblem")) || showOrnnItems && info.tags.includes("Artifact") || showOtherItems && info.tags.includes("Other") || showSupportItems && info.tags.includes("Support") || showRadiantItems && info.tags.includes("Radiant");
            }
            catch (e){
              passItemTyp = false;
            }
          }
          if (passItemTyp) {
            if (search === "") {
              return true;
            } else {
              return Belt_SetString.has(searchIds, id);
            }
          } else {
            return false;
          }
        }), [
        search,
        showNormalItems,
        showOrnnItems,
        showEmblems,
        showRadiantItems,
        showSupportItems,
        showOtherItems
      ]);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: React.createElement("div", {
                        className: "mx-auto max-w-[900px]"
                      }, React.createElement(ContentSection.make, {
                            className: "px-0 py-3",
                            children: null
                          }, React.createElement("div", {
                                className: "flex flex-col gap-1 flex-wrap pl-4 pb-1 mt-[-4px] select-none"
                              }, React.createElement("div", undefined, React.createElement(SearchField2.make, {
                                        search: search,
                                        setSearch: match[1]
                                      })), React.createElement("div", {
                                    className: "flex items-center flex-wrap"
                                  }, React.createElement("div", {
                                        className: "pr-3"
                                      }, t("Items Shown") + ": "), React.createElement(FormControlLabel, {
                                        control: React.createElement(Checkbox, {
                                              checked: showNormalItems,
                                              onChange: (function (e) {
                                                  var checked = e.target.checked;
                                                  return Curry._1(setShowNormalItems, (function (param) {
                                                                return checked;
                                                              }));
                                                }),
                                              color: "primary"
                                            }),
                                        label: t("Craftable")
                                      }), React.createElement(FormControlLabel, {
                                        control: React.createElement(Checkbox, {
                                              checked: showOrnnItems,
                                              onChange: (function (e) {
                                                  var checked = e.target.checked;
                                                  return Curry._1(setShowOrnnItems, (function (param) {
                                                                return checked;
                                                              }));
                                                }),
                                              color: "primary"
                                            }),
                                        label: t("Artifacts")
                                      }), React.createElement(FormControlLabel, {
                                        control: React.createElement(Checkbox, {
                                              checked: showEmblems,
                                              onChange: (function (e) {
                                                  var checked = e.target.checked;
                                                  return Curry._1(setShowEmblems, (function (param) {
                                                                return checked;
                                                              }));
                                                }),
                                              color: "primary"
                                            }),
                                        label: t("Emblem")
                                      }), React.createElement(FormControlLabel, {
                                        control: React.createElement(Checkbox, {
                                              checked: showRadiantItems,
                                              onChange: (function (e) {
                                                  var checked = e.target.checked;
                                                  return Curry._1(setShowRadiantItems, (function (param) {
                                                                return checked;
                                                              }));
                                                }),
                                              color: "primary"
                                            }),
                                        label: t("Radiant")
                                      }), React.createElement(FormControlLabel, {
                                        control: React.createElement(Checkbox, {
                                              checked: showSupportItems,
                                              onChange: (function (e) {
                                                  var checked = e.target.checked;
                                                  return Curry._1(setShowSupportItems, (function (param) {
                                                                return checked;
                                                              }));
                                                }),
                                              color: "primary"
                                            }),
                                        label: t("Support")
                                      }), React.createElement(FormControlLabel, {
                                        control: React.createElement(Checkbox, {
                                              checked: showOtherItems,
                                              onChange: (function (e) {
                                                  var checked = e.target.checked;
                                                  return Curry._1(setShowOtherItems, (function (param) {
                                                                return checked;
                                                              }));
                                                }),
                                              color: "primary"
                                            }),
                                        label: t("Other")
                                      }))), React.createElement("div", {
                                className: tableClass.join(" ")
                              }, React.createElement(StatsTable2.make, {
                                    cols: cols,
                                    data: data,
                                    context: context,
                                    keyFn: keyFn,
                                    stickyColCount: 1,
                                    defaultSortIdx: 1,
                                    visibleFilter: visibleFilter
                                  }))))
                }));
}

var make = ItemsPage;

export {
  cols ,
  make ,
  
}
/* cols Not a pure module */
